export const messageConfig = {
  name: 'Please enter compilation name',
  image: 'Please select image',
  captions: 'please select captions',
  compilationSuccess: 'Compilation created successfully',
  tilesSuccess: 'Tiles created successfully',
  imageUploadSuccess: 'Image uploaded successfully',
  errorMessage: 'This field is required',
  emailRequired: 'Email is required',
  passwordRequired: 'Password is required'
};

export default messageConfig;
